import { render, staticRenderFns } from "./BroadcastPortal.vue?vue&type=template&id=6f77d6c6&scoped=true&"
import script from "./BroadcastPortal.vue?vue&type=script&lang=js&"
export * from "./BroadcastPortal.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastPortal.vue?vue&type=style&index=0&id=6f77d6c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f77d6c6",
  null
  
)

export default component.exports